import React from "react";
import { IoCheckmarkCircle, IoEllipseOutline } from "react-icons/io5";
import { PASSWORD_RULES } from "../utils/passwordValidation";

const PasswordRequirements = ({ password, touched = true }) => {
  if (!touched) return null;

  return (
    <ul
      className="list-unstyled text-start mt-2 mb-0 ps-2"
      style={{ fontSize: "12px" }}
      aria-live="polite"
    >
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <li
            key={rule.id}
            className="d-flex align-items-center gap-2"
            style={{ color: passed ? "#2E7D32" : "#C62828" }}
          >
            {passed ? <IoCheckmarkCircle /> : <IoEllipseOutline />}
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
